import { STAFFING_STATUS } from './constants'

export default {
  getStaffingStatus() {
    return status => {
      return STAFFING_STATUS[status]
    }
  }
}
